// Shared admin "Edit Mode" state — persisted so it survives navigation.
// Toggled from the admin nav bar (AdminNavTools) and consumed by
// InlineTextEditor on every page. Non-admins ignore it entirely.
const KEY = 'ave_edit_mode';
const listeners = new Set();

export const getEditMode = () => localStorage.getItem(KEY) === '1';

export const setEditMode = (on) => {
  if (on) localStorage.setItem(KEY, '1');
  else localStorage.removeItem(KEY);
  listeners.forEach((l) => l());
};

export const subscribeEditMode = (listener) => {
  listeners.add(listener);
  window.addEventListener('storage', listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('storage', listener);
  };
};
